import { useState } from "react";
import { SelectOption } from "./Select";
import SearchInput from "./SearchInput";
import Tags from "@/components/Tags";

interface SearchSelectProps {
  label: string;
  name: string;
  placeholder?: string;
  reloadPropName: string;
  queryParam?: string;
  errors?: string;
  minChars?: number;
  value?: SelectOption[];
  onChange?: (items: SelectOption[]) => void;
}

const SearchSelect: React.FC<SearchSelectProps> = ({
  label,
  name,
  placeholder = "Search...",
  reloadPropName,
  queryParam,
  errors,
  minChars,
  value,
  onChange,
}) => {
  const [internalSelectedItems, setInternalSelectedItems] = useState<
    SelectOption[]
  >([]);

  const isControlled = value !== undefined;
  const selectedItems = isControlled ? value : internalSelectedItems;

  const handleSelect = (option: SelectOption) => {
    if (selectedItems.find((item) => item.value === option.value)) return;

    const newItems = [...selectedItems, option];
    if (isControlled && onChange) {
      onChange(newItems);
    } else {
      setInternalSelectedItems(newItems);
    }
  };

  const handleRemove = (index: number) => {
    const newItems = selectedItems.filter((_, i) => i !== index);
    if (isControlled && onChange) {
      onChange(newItems);
    } else {
      setInternalSelectedItems(newItems);
    }
  };

  return (
    <div className="flex w-full flex-col gap-2">
      <SearchInput
        label={label}
        placeholder={placeholder}
        reloadPropName={reloadPropName}
        queryParam={queryParam}
        errors={errors}
        minChars={minChars}
        onSelect={handleSelect}
        selectedValues={selectedItems.map((i) => i.value)}
      />
      {selectedItems.length > 0 && (
        <Tags
          tags={selectedItems.map((item) => item.label)}
          onRemove={handleRemove}
        />
      )}
      {selectedItems.map((item) => (
        <input key={item.value} type="hidden" name={name} value={item.value} />
      ))}
    </div>
  );
};

export default SearchSelect;
